import {
  LANDING_BRAND_NAME, LANDING_BRAND_SUFFIX, LANDING_LOGO_URL,
} from '../constants/posLandingConst';

/**
 * The landing page's logo lock-up: "Kawnter POS", linking back to the top.
 *
 * @param {object} props
 * @param {React.CSSProperties} [props.suffixStyle] - the footer tints "POS" mint
 * @returns {JSX.Element}
 */
function PosLandingBrand({ suffixStyle }) {
  return (
    <a className="brand" href="#top">
      <img src={LANDING_LOGO_URL} alt="" />
      {' '}
      {LANDING_BRAND_NAME}
      {' '}
      <span style={suffixStyle}>{LANDING_BRAND_SUFFIX}</span>
    </a>
  );
}

export default PosLandingBrand;
